/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Make all registered marks, TM, etc superscript
document.addEventListener('DOMContentLoaded', function() {
    const regex = /[®†™]/g;
    const elements = document.body.getElementsByTagName('*');
    
    for (let element of elements) {
        element.childNodes.forEach(node => {
            if (node.nodeType === 3 && // Text node
                node.parentElement.tagName !== 'SCRIPT' && 
                node.parentElement.tagName !== 'SUP') {
                
                const text = node.textContent;
                if (regex.test(text)) {
                    const wrapper = document.createElement('span');
                    wrapper.innerHTML = text.replace(regex, match => `<sup>${match}</sup>`);
                    node.replaceWith(wrapper);
                }
            }
        });
    }
});

function openTabs(evt, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("manual-content");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "block";
  evt.currentTarget.className += " active";
}


$(".announcement-nav-bar .nav-bar__item .custom_set").focus(function(e){
    $(this).attr("aria-expanded",true);
    $(this).parent().css("z-index","555");
  $(this).parent().find(".nav-dropdown").attr("aria-hidden",false);
  $(this).parent().find(".nav-dropdown").css("z-index","555");
    $(this).parent().find(".nav-dropdown").css("display","block");
     $(this).parent().find(".nav-dropdown .nav-dropdown__item").css("z-index","555");
  $(this).parent().find(".nav-dropdown .nav-dropdown__item").attr("tab-index","0");
});
$(".announcement-nav-bar .nothave_child a").focus(function(e){
    $(".announcement-nav-bar .nav-bar__item .custom_set").attr("aria-expanded",false);
    $(".announcement-nav-bar .nav-bar__item .nav-dropdown").css("display","none");
});

///Product Page Slider Zoom Image 

// setTimeout(function () {
//   $('.product-gallery__thumbnail-list').slick({ 
//     autoplay: false,
//     arrows: true,
//     verticalSwiping: false,
//     infinite: false,
//     prevArrow: '<div class="slick-prev" tabindex="0"><i class="fa fa-angle-up" aria-hidden="true"></i></div>',
//     nextArrow: '<div class="slick-next" tabindex="0"><i class="fa fa-angle-down" aria-hidden="true"></i></div>',
//     slidesToShow: 6,
//     vertical: true,
//     adaptiveHeight: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: "unslick",
//       },
//       {
//         breakpoint: 600,
//         settings: "unslick",
//       },
//     ],
//       });
//       }, 10000);
      $('[data-fancybox]').fancybox({
      loop : true
      });

      $(".product-gallery__image").hover(
      function() {
      $(".change-text").text("Click to open expanded view");
      },
      function() {
      $(".change-text").text('Roll over image to zoom in');
      }
      );
 //Scroll
      
      $(".table-box a[href]").click(function(e) {
             e.preventDefault();
             var position = $($(this).attr("href")).offset().top-100;
              //console.log(position);
          $("body, html").animate({
          	scrollTop: position
      		} /* speed */ );
      });

document.addEventListener("DOMContentLoaded", function () {
    const paymentContainer = document.querySelector(".product-form__payment-container");
    const productInfoSection = document.querySelector(".product-block-list__item--info");

    if (!paymentContainer || window.innerWidth > 768) return; // Only run on mobile

    // Correctly check if the attribute is set to "true"
    const isFloatingBtn = paymentContainer.getAttribute("data-floating-btn") === "true"; 
    console.log(isFloatingBtn, "isFloatingBtn");

    if (!isFloatingBtn) return; // Stop execution if floating button is disabled

    let isFloating = false; // Prevent rapid toggling

    // Intersection Observer setup
    const observer = new IntersectionObserver(entries => {
        const entry = entries[0];

        if (!entry.isIntersecting && !isFloating) {
            isFloating = true;
            paymentContainer.classList.add("visible");
        } else if (entry.isIntersecting && isFloating) {
            isFloating = false;
            paymentContainer.classList.remove("visible");
        }
    }, { threshold: 0.1, rootMargin: "30px 0px 0px 0px" }); // Add a small margin to prevent flickering

    observer.observe(productInfoSection);
});